<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Habilitados ({{ activeArrData.length }})">
    <perfect-scrollbar class="slides-scrollbar"
      [config]="{useBothWheelAxes: false, suppressScrollX: false, suppressScrollY: true}">
      <div class="slides-content">
        <div *ngFor="let banner of activeArrData, index as i">
          <mat-card class="banner has-outline-menu bannerPromo" *ngIf="banner.active === 0">
            <div class="vs-crud-menu">
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Banner"
                (click)="editBanner(banner)">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                [matTooltip]="banner.active === 0 ? 'Deshabilitar Banner' :  'Habilitar Banner'"
                (click)="changeStatus(banner, banner.active)">
                <mat-icon>{{ banner.active === 0 ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Banner"
                (click)="delete(banner)">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
            <div class="row text-center">
              <div class="col-12 mb-5">
                <img [src]="banner.bannerPromoImages[0].img1" class="banner-promo-preview" [alt]="banner.title"
                  onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              </div>
              <div class="col-12" *ngIf="banner.isShowing">
                <img class="banner-promo-trafficlight" alt="Activo" src='assets/images/icons/trafficlight-green.png'>
              </div>
              <div class=" col-12 mb-5">
                <img [src]="banner.bannerPromoImages[0].img2" class="banner-promo-preview" [alt]="banner.title"
                  onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              </div>
              <div class="col-12 mb-5">
                <img [src]="banner.img3" class="banner-promo-preview" [alt]="banner.title"
                  onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              </div>
              <div class=" col-12">
                <p class="input-label">Título</p>
                <h2>{{banner.title}}</h2>
              </div>
              <div class="col-12">
                <p class="input-label"> Fechas
                  {{getFormatDate(banner.dateFrom) }} - {{getFormatDate(banner.dateTo)}}
                </p>
              </div>
              <div class=" col-12">
                <p class="input-label">Es por defecto:
                  <span *ngIf="banner.isDefault; else  elseBlock">Si</span>
                  <ng-template #elseBlock>No</ng-template>
                </p>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </perfect-scrollbar>
  </mat-tab>
  <mat-tab label="Deshabilitados ({{ inactiveArrData.length }})">
    <perfect-scrollbar class="slides-scrollbar"
      [config]="{useBothWheelAxes: false, suppressScrollX: false, suppressScrollY: true}">
      <div class="slides-content disabled-content">
        <div *ngFor="let banner of inactiveArrData, index as i">
          <mat-card class="banner has-outline-menu bannerPromo" *ngIf="banner.active === 1">
            <div class="vs-crud-menu">
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                [matTooltip]="banner.active === 0 ? 'Deshabilitar Banner' :  'Habilitar Banner'"
                (click)="changeStatus(banner, banner.active)">
                <mat-icon>{{ banner.active === 0 ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Banner"
                (click)="delete(banner)">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
            <div class="row text-center">
              <div class="col-12 mb-5">
                <img width="405px" heigth="320px" [src]="banner.bannerPromoImages[0].img1" class="banner-preview" [alt]="banner.title"
                  onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              </div>
              <div class=" col-12">
                <p class="input-label">Título</p>
                <h2>{{banner.title}}</h2>
              </div>
              <div class=" col-12">
                <p class="input-label"> Fechas
                  {{ getFormatDate(banner.dateFrom) }} - {{getFormatDate(banner.dateTo)}}
                </p>
              </div>
              <div class=" col-12">
                <p class="input-label">Es por defecto:
                  <span *ngIf="banner.isDefault; else  elseBlock">Si</span>
                  <ng-template #elseBlock>No</ng-template>
                </p>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </perfect-scrollbar>
  </mat-tab>
</mat-tab-group>